import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, viewChild } from '@angular/core';

import { StoreLocatorFacade } from '../../facades/store-locator.facade';

@Component({
  selector: 'ish-stores-map',
  templateUrl: './stores-map.component.html',
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: false,
})
export class StoresMapComponent implements AfterViewInit {
  readonly mapContainer = viewChild<ElementRef>('mapContainer');

  constructor(private storeLocatorFacade: StoreLocatorFacade) {}

  ngAfterViewInit() {
    this.storeLocatorFacade.loadMap(this.mapContainer().nativeElement);
  }
}
